import React, { Component } from 'react';
import { Platform, Dimensions, View, Image, Text, StyleSheet, TouchableOpacity } from 'react-native';

class PostImage extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        return (<a href={this.props.source.uri} target="_blank"
                   onClick={(e) => {
                       e.stopPropagation();
                   }}>
                    <Image {...this.props} />
                </a>);
    }
};

export default PostImage;
